import React from "react";
import type { FC, ReactNode } from "react";
import { Redirect } from "react-router-dom";
import useAuth from "../hooks/useAuth";

interface GuestGuardProps {
  children?: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Redirect to="/account" />;
  }

  return <>{children}</>;
};

export default GuestGuard;
